module.exports = __webpack_public_path__ + "img/projects-1.11bbec24.jpg";